<span kendoTooltip>
  <input
    [checked]="enabled"
    [disabled]="!enabled"
    kendoCheckBox
    type="checkbox"
    [attr.title]="enabled ? enabledTooltip : disabledTooltip"
  />
</span>
